import { useState, useEffect } from "react";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import debounce from "lodash/debounce";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import { onKeyActivate } from "@/utils/index";

/**
 * 侧边栏
 * @returns 侧边栏组件
 */
const SideBar = () => {
  const { t } = useTranslation();

  const { isSmallScreen } = useAppSelector((state: RootState) => state.app);

  // 返回顶部是否显示
  const [goTop, setGoTop] = useState<boolean>(false);

  // 处理滚动事件的逻辑
  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop >= (!isSmallScreen ? 900 : 812)) {
      setGoTop(true);
    } else {
      setGoTop(false);
    }
  };

  useEffect(() => {
    // 使用防抖
    const debouncedScrollHandler = debounce(handleScroll, 200);
    window.addEventListener("scroll", debouncedScrollHandler);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="fixed bottom-28 right-0 z-50 flex min-w-[48px] flex-col rounded-md bg-white text-sm  font-semibold text-stone-800 transition-all md:min-w-[88px]"
      style={{ boxShadow: "0 2px 14px 0 rgba(0, 0, 0, 0.1)" }}
    >
      {goTop && (
        <div
          className="flex cursor-pointer flex-col items-center justify-center p-4 transition-opacity hover:opacity-80"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }}
          role="button"
          tabIndex={0}
          onKeyDown={onKeyActivate(() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" }))}
        >
          <Image
            src="/images/aside/top.png"
            title="go top"
            alt="go top"
            width={24}
            height={24}
            className="h-4 w-4 md:h-6 md:w-6"
          />
          <div className="mt-2 hidden md:block">{t("common.go_top")}</div>
        </div>
      )}
    </div>
  );
};

export default SideBar;
